import { fromJS } from 'immutable';
import * as actions from '../../actions/equityFinder/configurations';
import { fetchingState } from '../../constants';

const initialStats = {
  categoryList: {},
  configuration: {},
  regressionRuleSets: {},
  regressionRuleSet: {},
  compSelectionRules: {},
  globalScoringRules: {},
  globalScoringRule: {},
  compGridConfiguration: {},
  compGridOption: {},
  systemConfiguration: {},
  baseUnitList: {},
  baseUnit: {},
  prodigyScoreList: {},
  templateList: {},
  template: {},
};

export default (state = fromJS(initialStats), action) => {
  switch (action.type) {
    case actions.CONFIGURATIONS_CATEGORIES_FETCH_START:
      return state.setIn(['categoryList', 'state'], fetchingState.FETCHING);
    case actions.CONFIGURATIONS_CATEGORIES_FETCH_SUCCESS:
      let newState = state.setIn(
        ['categoryList', 'state'],
        fetchingState.LOADED,
      );
      return newState.setIn(
        ['categoryList', 'data'],
        fromJS(action.data ? action.data.results : []),
      );
    case actions.CONFIGURATIONS_CATEGORIES_FETCH_ERROR:
      return state.setIn(['categoryList', 'state'], fetchingState.ERROR);

    case actions.CONFIGURATIONS_CATEGORY_CONFIG_FETCH_START:
      return state.setIn(['configuration', 'state'], fetchingState.FETCHING);
    case actions.CONFIGURATIONS_CATEGORY_CONFIG_FETCH_SUCCESS:
      newState = state.setIn(['configuration', 'state'], fetchingState.LOADED);
      return newState.setIn(
        ['configuration', 'data'],
        fromJS(action.data.results),
      );
    case actions.CONFIGURATIONS_CATEGORY_CONFIG_FETCH_ERROR:
      return state.setIn(['configuration', 'state'], fetchingState.ERROR);

    case actions.CONFIGURATIONS_REGRESSION_RULESET_FETCH_START:
      return state.setIn(
        ['regressionRuleSet', 'state'],
        fetchingState.FETCHING,
      );
    case actions.CONFIGURATIONS_REGRESSION_RULESET_FETCH_SUCCESS:
      newState = state.setIn(
        ['regressionRuleSet', 'state'],
        fetchingState.LOADED,
      );
      return newState.setIn(
        ['regressionRuleSet', 'data'],
        fromJS(action.data ? action.data.results : []),
      );
    case actions.CONFIGURATIONS_REGRESSION_RULESET_FETCH_ERROR:
      return state.setIn(['regressionRules', 'state'], fetchingState.ERROR);

    case actions.CONFIGURATIONS_REGRESSION_RULE_ADD_SUCCESS:
      let newRegressionRuleSet = state.getIn(['regressionRuleSet', 'data'])
        ? state.getIn(['regressionRuleSet', 'data']).toJS()
        : [];
      newRegressionRuleSet.push(action.data.results[0]);
      return state.setIn(
        ['regressionRuleSet', 'data'],
        fromJS(newRegressionRuleSet),
      );

    case actions.CONFIGURATIONS_REGRESSION_RULE_EDIT_SUCCESS:
      newRegressionRuleSet = state.getIn(['regressionRuleSet', 'data']).toJS();
      let searchIndex = newRegressionRuleSet.findIndex(
        (value) => value.ruleID === action.data.results[0].ruleID,
      );
      newRegressionRuleSet[searchIndex] = action.data.results[0];
      return state.setIn(
        ['regressionRuleSet', 'data'],
        fromJS(newRegressionRuleSet),
      );

    case actions.CONFIGURATIONS_REGRESSION_RULE_DELETE_SUCCESS:
      newRegressionRuleSet = state.getIn(['regressionRuleSet', 'data']).toJS();
      newRegressionRuleSet = newRegressionRuleSet.filter(
        (rule) => rule.ruleID !== action.ruleId,
      );
      return state.setIn(
        ['regressionRuleSet', 'data'],
        fromJS(newRegressionRuleSet),
      );

    case actions.CONFIGURATIONS_REGRESSION_RULESETS_FETCH_START:
      return state.setIn(
        ['regressionRuleSets', 'state'],
        fetchingState.FETCHING,
      );
    case actions.CONFIGURATIONS_REGRESSION_RULESETS_FETCH_SUCCESS:
      newState = state.setIn(
        ['regressionRuleSets', 'state'],
        fetchingState.LOADED,
      );
      return newState.setIn(
        ['regressionRuleSets', 'data'],
        fromJS(action.data && action.data.results ? action.data.results : []),
      );
    case actions.CONFIGURATIONS_REGRESSION_RULESETS_FETCH_ERROR:
      return state.setIn(['regressionRuleSets', 'state'], fetchingState.ERROR);

    case actions.CONFIGURATIONS_REGRESSION_RULESET_ADD_SUCCESS:
      let newRegressionRuleSets = state.getIn(['regressionRuleSets', 'data'])
        ? state.getIn(['regressionRuleSets', 'data']).toJS()
        : [];
      newRegressionRuleSets.push(action.data.results[0]);
      return state.setIn(
        ['regressionRuleSets', 'data'],
        fromJS(newRegressionRuleSets),
      );

    case actions.CONFIGURATIONS_REGRESSION_RULESET_EDIT_SUCCESS:
      newRegressionRuleSets = state
        .getIn(['regressionRuleSets', 'data'])
        .toJS();
      searchIndex = newRegressionRuleSets.findIndex(
        (value) => value.rulesetID === action.data.results[0].rulesetID,
      );
      newRegressionRuleSets[searchIndex] = action.data.results[0];
      return state.setIn(
        ['regressionRuleSets', 'data'],
        fromJS(newRegressionRuleSets),
      );

    case actions.CONFIGURATIONS_REGRESSION_RULESET_DELETE_SUCCESS:
      newRegressionRuleSets = state
        .getIn(['regressionRuleSets', 'data'])
        .toJS();
      newRegressionRuleSets = newRegressionRuleSets.filter(
        (rule) => rule.rulesetID !== action.ruleSetId,
      );
      return state.setIn(
        ['regressionRuleSets', 'data'],
        fromJS(newRegressionRuleSets),
      );

    case actions.CONFIGURATIONS_REGRESSION_RULESET_COPY_SUCCESS:
      return state.setIn(
        ['regressionRuleSets', 'data'],
        fromJS(action.data.results),
      );

    case actions.CONFIGURATIONS_REGRESSION_RULESETS_SETORDER_SUCCESS:
      return state.setIn(
        ['regressionRuleSets', 'data'],
        fromJS(action.data.results),
      );

    case actions.CONFIGURATIONS_COMPSELECTION_RULES_FETCH_START:
      return state.setIn(
        ['compSelectionRules', 'state'],
        fetchingState.FETCHING,
      );
    case actions.CONFIGURATIONS_COMPSELECTION_RULES_FETCH_SUCCESS:
      newState = state.setIn(
        ['compSelectionRules', 'state'],
        fetchingState.LOADED,
      );
      return newState.setIn(
        ['compSelectionRules', 'data'],
        fromJS(action.data && action.data.results ? action.data.results : []),
      );
    case actions.CONFIGURATIONS_COMPSELECTION_RULES_FETCH_ERROR:
      return state.setIn(['compSelectionRules', 'state'], fetchingState.ERROR);

    case actions.CONFIGURATIONS_COMPSELECTION_RULE_ADD_SUCCESS:
      let newCompSelectionRules = state.getIn(['compSelectionRules', 'data'])
        ? state.getIn(['compSelectionRules', 'data']).toJS()
        : [];
      newCompSelectionRules.push(action.data.results[0]);
      return state.setIn(
        ['compSelectionRules', 'data'],
        fromJS(newCompSelectionRules),
      );

    case actions.CONFIGURATIONS_COMPSELECTION_RULE_EDIT_SUCCESS:
      newCompSelectionRules = state
        .getIn(['compSelectionRules', 'data'])
        .toJS();
      searchIndex = newCompSelectionRules.findIndex(
        (value) => value.ruleID === action.data.results[0].ruleID,
      );
      newCompSelectionRules[searchIndex] = action.data.results[0];
      return state.setIn(
        ['compSelectionRules', 'data'],
        fromJS(newCompSelectionRules),
      );

    case actions.CONFIGURATIONS_COMPSELECTION_RULE_DELETE_SUCCESS:
      newCompSelectionRules = state
        .getIn(['compSelectionRules', 'data'])
        .toJS();
      newCompSelectionRules = newCompSelectionRules.filter(
        (rule) => rule.ruleID !== action.ruleId,
      );
      return state.setIn(
        ['compSelectionRules', 'data'],
        fromJS(newCompSelectionRules),
      );

    case actions.CONFIGURATIONS_GLOBAL_SCORING_RULES_FETCH_START:
      return state.setIn(
        ['globalScoringRules', 'state'],
        fetchingState.FETCHING,
      );
    case actions.CONFIGURATIONS_GLOBAL_SCORING_RULES_FETCH_SUCCESS:
      newState = state.setIn(
        ['globalScoringRules', 'state'],
        fetchingState.LOADED,
      );
      return newState.setIn(
        ['globalScoringRules', 'data'],
        fromJS(action.data ? action.data.results : []),
      );
    case actions.CONFIGURATIONS_GLOBAL_SCORING_RULES_FETCH_ERROR:
      return state.setIn(['globalScoringRules', 'state'], fetchingState.ERROR);

    case actions.CONFIGURATIONS_GLOBAL_SCORING_RULE_FETCH_START:
      return state.setIn(
        ['globalScoringRule', 'state'],
        fetchingState.FETCHING,
      );
    case actions.CONFIGURATIONS_GLOBAL_SCORING_RULE_FETCH_SUCCESS:
      newState = state.setIn(
        ['globalScoringRule', 'state'],
        fetchingState.LOADED,
      );
      return newState.setIn(
        ['globalScoringRule', 'data'],
        fromJS(action.data.results),
      );
    case actions.CONFIGURATIONS_GLOBAL_SCORING_RULE_FETCH_ERROR:
      return state.setIn(['globalScoringRule', 'state'], fetchingState.ERROR);

    case actions.CONFIGURATIONS_GLOBAL_SCORING_RULE_EDIT_SUCCESS:
      return state.setIn(
        ['globalScoringRule', 'data'],
        fromJS(action.data.results),
      );

    case actions.CONFIGURATIONS_GLOBAL_SCORING_RULE_ADD_SUCCESS:
      newCompSelectionRules = state.getIn(['globalScoringRules', 'data'])
        ? state.getIn(['globalScoringRules', 'data']).toJS()
        : [];
      newCompSelectionRules.push(action.data.results[0]);
      return state.setIn(
        ['globalScoringRules', 'data'],
        fromJS(newCompSelectionRules),
      );

    case actions.CONFIGURATIONS_GLOBAL_SCORING_RULE_DELETE_SUCCESS:
      let newGlobalScoringRules = state
        .getIn(['globalScoringRules', 'data'])
        .toJS();
      newGlobalScoringRules = newGlobalScoringRules.filter(
        (rule) => rule.ruleID !== action.ruleId,
      );
      return state.setIn(
        ['globalScoringRules', 'data'],
        fromJS(newGlobalScoringRules),
      );

    case actions.CONFIGURATIONS_CATEGORY_ADD_SUCCESS:
      let newCategoryList = state.getIn(['categoryList', 'data'])
        ? state.getIn(['categoryList', 'data']).toJS()
        : [];
      newCategoryList.push(action.data.results[0]);
      return state.setIn(['categoryList', 'data'], fromJS(newCategoryList));

    case actions.CONFIGURATIONS_CATEGORY_UPDATE_SUCCESS:
      newCategoryList = state.getIn(['categoryList', 'data']).toJS();
      searchIndex = newCategoryList.findIndex(
        (value) => value.categoryID === action.data.results[0].categoryID,
      );
      newCategoryList[searchIndex] = action.data.results[0];
      return state.setIn(['categoryList', 'data'], fromJS(newCategoryList));

    case actions.CONFIGURATIONS_CATEGORY_DELETE_SUCCESS:
      newCategoryList = state.getIn(['categoryList', 'data']).toJS();
      newCategoryList = newCategoryList.filter(
        (category) => category.categoryID !== action.categoryId,
      );
      return state.setIn(['categoryList', 'data'], fromJS(newCategoryList));

    case actions.COMPGRID_CONFIGURATIONS_FETCH_START:
      return state.setIn(
        ['compGridConfiguration', 'state'],
        fetchingState.FETCHING,
      );
    case actions.COMPGRID_CONFIGURATIONS_FETCH_SUCCESS:
      newState = state.setIn(
        ['compGridConfiguration', 'state'],
        fetchingState.LOADED,
      );
      return newState.setIn(
        ['compGridConfiguration', 'data'],
        fromJS(action.data ? action.data.results : []),
      );
    case actions.COMPGRID_CONFIGURATIONS_FETCH_ERROR:
      return state.setIn(
        ['compGridConfiguration', 'state'],
        fetchingState.ERROR,
      );

    case actions.COMPGRID_OPTION_FETCH_START:
      return state.setIn(['compGridOption', 'state'], fetchingState.FETCHING);
    case actions.COMPGRID_OPTION_FETCH_SUCCESS:
      newState = state.setIn(['compGridOption', 'state'], fetchingState.LOADED);
      return newState.setIn(
        ['compGridOption', 'data'],
        fromJS(action.data ? action.data.results : []),
      );
    case actions.COMPGRID_OPTION_FETCH_ERROR:
      return state.setIn(['compGridOption', 'state'], fetchingState.ERROR);

    case actions.SYSTEM_CONFIGURATIONS_FETCH_START:
      return state.setIn(
        ['systemConfiguration', 'state'],
        fetchingState.FETCHING,
      );
    case actions.SYSTEM_CONFIGURATIONS_FETCH_SUCCESS:
      newState = state.setIn(
        ['systemConfiguration', 'state'],
        fetchingState.LOADED,
      );
      return newState.setIn(
        ['systemConfiguration', 'data'],
        fromJS(action.data ? action.data.results : []),
      );
    case actions.SYSTEM_CONFIGURATIONS_FETCH_ERROR:
      return state.setIn(['systemConfiguration', 'state'], fetchingState.ERROR);

    case actions.BASE_UNIT_LIST_FETCH_START:
      return state.setIn(['baseUnitList', 'state'], fetchingState.FETCHING);
    case actions.BASE_UNIT_LIST_FETCH_SUCCESS:
      newState = state.setIn(['baseUnitList', 'state'], fetchingState.LOADED);
      return newState.setIn(
        ['baseUnitList', 'data'],
        fromJS(action.data ? action.data.results : []),
      );
    case actions.BASE_UNIT_LIST_FETCH_ERROR:
      return state.setIn(['baseUnitList', 'state'], fetchingState.ERROR);

    case actions.BASE_UNIT_FETCH_START:
      return state.setIn(['baseUnit', 'state'], fetchingState.FETCHING);
    case actions.BASE_UNIT_FETCH_SUCCESS:
      newState = state.setIn(['baseUnit', 'state'], fetchingState.LOADED);
      return newState.setIn(['baseUnit', 'data'], fromJS(action.data.results));
    case actions.BASE_UNIT_FETCH_ERROR:
      return state.setIn(['baseUnit', 'state'], fetchingState.ERROR);

    case actions.BASE_UNIT_ADD_SUCCESS:
      return state.setIn(['baseUnitList', 'data'], fromJS(action.data.results));

    case actions.BASE_UNIT_EDIT_SUCCESS:
      let newBaseUnitList = state.getIn(['baseUnitList', 'data']).toJS();
      searchIndex = newBaseUnitList.findIndex(
        (value) => value.id === action.data.results[0].id,
      );
      newBaseUnitList[searchIndex] = action.data.results[0];
      return state.setIn(['baseUnitList', 'data'], fromJS(newBaseUnitList));

    case actions.BASE_UNIT_DELETE_SUCCESS:
      newBaseUnitList = state.getIn(['baseUnitList', 'data']).toJS();
      newBaseUnitList = newBaseUnitList.filter(
        (value) => value.id !== action.id,
      );
      return state.setIn(['baseUnitList', 'data'], fromJS(newBaseUnitList));

    case actions.PRODIGY_SCORE_LIST_FETCH_START:
      return state.setIn(['prodigyScoreList', 'state'], fetchingState.FETCHING);
    case actions.PRODIGY_SCORE_LIST_FETCH_SUCCESS:
      newState = state.setIn(
        ['prodigyScoreList', 'state'],
        fetchingState.LOADED,
      );
      return newState.setIn(
        ['prodigyScoreList', 'data'],
        fromJS(action.data ? action.data.results : []),
      );
    case actions.PRODIGY_SCORE_LIST_FETCH_ERROR:
      return state.setIn(['prodigyScoreList', 'state'], fetchingState.ERROR);

    case actions.PRODIGY_SCORE_EDIT_SUCCESS:
      const newProdigyScoreList = state
        .getIn(['prodigyScoreList', 'data'])
        .toJS();
      searchIndex = newProdigyScoreList.findIndex(
        (value) => value.id === action.data.results[0].id,
      );
      newProdigyScoreList[searchIndex] = action.data.results[0];
      return state.setIn(
        ['prodigyScoreList', 'data'],
        fromJS(newProdigyScoreList),
      );

    case actions.TEMPLATES_FETCH_START:
      return state.setIn(['templateList', 'state'], fetchingState.FETCHING);
    case actions.TEMPLATES_FETCH_SUCCESS:
      newState = state.setIn(['templateList', 'state'], fetchingState.LOADED);
      return newState.setIn(
        ['templateList', 'data'],
        fromJS(action.data ? action.data.results : []),
      );
    case actions.TEMPLATES_FETCH_ERROR:
      return state.setIn(['templateList', 'state'], fetchingState.ERROR);

    case actions.TEMPLATE_FETCH_START:
      return state.setIn(['template', 'state'], fetchingState.FETCHING);
    case actions.TEMPLATE_FETCH_SUCCESS:
      newState = state.setIn(['template', 'state'], fetchingState.LOADED);
      return newState.setIn(['template', 'data'], fromJS(action.data.results));
    case actions.TEMPLATE_FETCH_ERROR:
      return state.setIn(['template', 'state'], fetchingState.ERROR);

    case actions.TEMPLATE_CREATE_SUCCESS:
      let newTemplateList = state.getIn(['templateList', 'data']).toJS();
      newTemplateList = newTemplateList.concat(action.data.results);
      return state.setIn(['templateList', 'data'], fromJS(newTemplateList));

    case actions.TEMPLATE_DEFAULT_SET_SUCCESS:
      newTemplateList = state.getIn(['templateList', 'data']).toJS();
      newTemplateList = newTemplateList.map((t) => {
        if (t.templateID === action.data.results[0].templateID) {
          return {
            ...t,
            defaultTemplate: 1,
            defaultTemplateDisplay: 'Yes',
          };
        }
        return {
          ...t,
          defaultTemplate: 0,
          defaultTemplateDisplay: 'No',
        };
      });
      return state.setIn(['templateList', 'data'], fromJS(newTemplateList));

    case actions.TEMPLATE_UPDATE_SUCCESS:
      newTemplateList = state.getIn(['templateList', 'data']).toJS();
      searchIndex = newTemplateList.findIndex(
        (value) => value.templateID === action.data.results[0].templateID,
      );
      newTemplateList[searchIndex] = action.data.results[0];
      return state.setIn(['templateList', 'data'], fromJS(newTemplateList));

    case actions.TEMPLATE_DELETE_SUCCESS:
      newTemplateList = state.getIn(['templateList', 'data']).toJS();
      newTemplateList = newTemplateList.filter(
        (value) => value.templateID !== action.id,
      );
      return state.setIn(['templateList', 'data'], fromJS(newTemplateList));

    default:
      return state;
  }
};
